import { render } from "./MainLayout.vue?vue&type=template&id=9b8792b2&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=9b8792b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9b8792b2"

export default script